import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";
import { useState } from "react";

const MoodBanner = ({ blok }) => {
  

  return (
    <div /* style={{ display: `none`}} */ className="banner-img relative flex items-center justify-center"{...storyblokEditable(blok)}>
      <img
        src={blok.backgroundpicture.filename}
        alt={blok.backgroundpicture.alt}
      />
      <div className=" banner-content absolute flex items-center justify-end">
        <div className="banner-textcontent flex flex-col justify-center items-center">
          <h2 className="banner-headline text-5xl bold font-bold">{blok.headline}</h2>
          <span className="text-center">{blok.content}</span>
          <div className="flex">
            <Link href={blok.link} ><button>{blok.button}</button></Link>
          </div>
        </div>
      </div>
    </div>
  );};

export default MoodBanner;
